import React from "react";
import { createRoot } from "react-dom/client";
import OperatorScheduleData from "./OperatorScheduleData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorScheduleData: unknown;
	}
}

export function renderOperatorScheduleData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorScheduleData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorScheduleData = renderOperatorScheduleData;
